var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('h3',[_vm._v("Error: Not Found")]),_vm._m(0),_c('p',[_c('router-link',{attrs:{"to":`/${_vm.lang}/`}},[_vm._v("トップに戻る")])],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('p',[_vm._v(" 大会情報が見つかりませんでした。"),_c('br'),_vm._v(" URLに誤りがある、または大会が削除された可能性があります。 ")])
}]

export { render, staticRenderFns }